module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/900c51ce04ad85d6f41e64b212cf3e67.png";